export default "__VITE_PUBLIC_ASSET__330e7d8f__"